// extracted by mini-css-extract-plugin
export default {"label":"check-box-group__bAcGl"};